// extracted by mini-css-extract-plugin
export default {"message":"ConfigurationRestorer__message___o6uRS"};